/**
 * UpdateGroupValueOnNewGroupCreation
 */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { change } from 'redux-form';

// Selectors
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

interface Props {
    newGroupId?: number;
    name: string;
    change: Function;
    formName: string;
}

class UpdateGroupValueOnNewGroupCreation extends React.PureComponent<Props> {
    componentDidUpdate(prevProps) {
        const { newGroupId, name, formName } = this.props;
        if (newGroupId && newGroupId !== prevProps.newGroupId) {
            this.props.change(formName, name, newGroupId);
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    newGroupId: makeSelectQueryStringNumberValue('newGroup')
});

export default connect(
    mapStateToProps,
    { change }
)(UpdateGroupValueOnNewGroupCreation);
